import React from 'react';
import { Text, Stack, Flex } from '@chakra-ui/react';
import { QuestionHelper } from '../Data';
import RespondentQuestionChat from '../Chat/Respondent';
import RotuloClassificacao from '../Catalog/RotuloClassificacao';
import MedidasGriComoFormulario from '../Catalog/MedidasGriComoFormulario';

const QuestionCard = React.memo(function ({ surveyId, userId, question, companyId, children }) {
 const { code, description, is_required } = question;


 return (
  <Stack
   p='6'
   spacing='6'
   bg='white'
   border='2px solid #EAEEF0'
   borderRadius='12px'
   mt={['12px', '0']}
   pos='relative'
  >
   <Flex
    w='157px'
    height='44px'
    justify='end'
    align='center'
    pos='absolute'
    top={['12px', '6']}
    right='6'
   >
    <RespondentQuestionChat
     surveyId={surveyId}
     question={question}
     userId={userId}
     companyId={companyId || question?.company?.id_company?.toString() || ''}
     type='simple'
    />
   </Flex>

   <div>
    {is_required && (
     <Text
      as='span'
      color='orange.100'
      fontSize='12px'
      lineHeight='24px'
      display='block'
      fontWeight={500}
     >
      Pergunta obrigatória*
     </Text>
    )}

    <Text lineHeight='32px' mt='4px' maxW='86%'>
     <b>{code}</b> -{' '}
     <Text as='span' fontWeight={500} dangerouslySetInnerHTML={{ __html: description }} />
    </Text>

    <RotuloClassificacao
     idPillar={question?.id_pillar}
     idTheme={question?.id_theme}
     ocultarVazio
    />
   </div>

   <QuestionHelper
    description={question?.helper?.description || ''}
    videoUrl={question?.helper?.url_video || ''}
   />

   {children}

   {/* GRI-08: esta tela SIMULA o formulário do respondente, então mostra a
       caixa de medidas igual à de lá — campo por indicador, com a unidade no
       sufixo — e não a lista compacta da auditoria. Pelo mesmo motivo o selo
       "INDICADOR GRI" não aparece aqui: ele saiu do form quando a seção de
       medidas passou a ser o sinal. Nas telas próprias do painel (auditoria,
       template) o selo continua. */}
   <MedidasGriComoFormulario gri={question?.gri} />
  </Stack>
 );
});

export default QuestionCard;
